import { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ScrollToTop from '@/shared/components/ScrollToTop';
import ProtectedRoute from './ProtectedRoute';
import RemainingSerials from '@/views/ItemDetails/ItemSerials/RemainingSerials';
import SoldSerials from '@/views/ItemDetails/ItemSerials/SoldSerials';

const HomePage = lazy(() => import('@/views/Home/HomePage'));
const Items = lazy(() => import('@/views/Items/Items'));
const ItemDetails = lazy(() => import('@/views/ItemDetails/ItemDetails'));
const CategoryDetails = lazy(() => import('@/views/CategoryDetails').then(module => ({ default: module.CategoryDetails })));
const CategoryNames = lazy(() => import('@/views/CategoryDetails/CategoryNames'));
const ItemImageGallery = lazy(() => import('@/views/ItemDetails/ItemImageGallery'));
const ItemMovements = lazy(() => import('@/views/ItemDetails/ItemMovements'));
const ItemNames = lazy(() => import('@/views/ItemDetails/ItemNames'));
const ItemPriceList = lazy(() => import('@/views/ItemDetails/ItemPriceList'));
const ItemProperties = lazy(() => import('@/views/ItemDetails/ItemProperties'));
const ItemQty = lazy(() => import('@/views/ItemDetails/ItemQty'));
const GenerateSerials = lazy(() => import('@/views/ItemDetails/ItemSerials/GenerateSerials'));
const ItemSerial = lazy(() => import('@/views/ItemDetails/ItemSerials/ItemSerials'));
const ItemUnitBarcode = lazy(() => import('@/views/ItemDetails/ItemUnitBarcode'));
// const PrintItem = lazy(() => import('@/views/ItemDetails/PrintItem'));
const NotFoundPage = lazy(() => import('@/views/NotFound/NotFoundPage'));
const SearchByBarcode = lazy(() => import('@/views/SearchByBarcode').then(module => ({ default: module.SearchByBarcode })));
const SearchByItem = lazy(() => import('@/views/SearchByItems').then(module => ({ default: module.SearchByItem })));
const UpdateSerialQuantity = lazy(() => import('@/views/ItemDetails/ItemSerials/UpdateSerialQuantity'));
const UnauthorizedPage = lazy(() => import('@/views/Unauthorized/Unauthorized'));
const AddItem = lazy(() => import('@/views/Items/AddItem'));

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p></p>
      </div>}>
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/items" element={<Items />} />
            <Route path="/item_details/:id" element={<ItemDetails />} />
            <Route path="/search_by_barcode" element={<SearchByBarcode />} />
            <Route path="/search_by_item" element={<SearchByItem />} />
            <Route path="/gallery/:id/:name" element={<ItemImageGallery />} />
            <Route path="/item_names/:id" element={<ItemNames />} />
            <Route path="/item_unit_barcode/:id/:name" element={<ItemUnitBarcode />} />
            <Route path="/item_qty/:id/:name" element={<ItemQty />} />
            <Route path="/item_properties/:id/:name" element={<ItemProperties />} />
            <Route path="/item_price_list/:id/:name" element={<ItemPriceList />} />
            {/* <Route path="/print_item/:id/:name" element={<PrintItem />} /> */}
            <Route path="/item_movements/:id/:name" element={<ItemMovements />} />
            <Route path="/category_details/:id" element={<CategoryDetails />} />
            <Route path="/item_serials/:id/:name" element={<ItemSerial />} />
            <Route path="/cat_names/:id" element={<CategoryNames />} />
            <Route path="/generate_serials/:id/:name" element={<GenerateSerials />} />
            <Route path="/update_serial_quantity/:id/:name" element={<UpdateSerialQuantity />} />
            <Route path="/remaining_serials/:id/:name" element={<RemainingSerials />} />
            <Route path="/sold_serials/:id/:name" element={<SoldSerials />} />
            <Route path="/add_item" element={<AddItem />} />

          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
